import { render } from "./ResidenceCard.vue?vue&type=template&id=005adf70&scoped=true"
import script from "./ResidenceCard.vue?vue&type=script&lang=js"
export * from "./ResidenceCard.vue?vue&type=script&lang=js"

import "./ResidenceCard.vue?vue&type=style&index=0&id=005adf70&lang=scss&scoped=true"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-005adf70"]])

export default __exports__